<template>
  <div>
    <v-card>
        <v-card-title
          class="text_primary pb-0"
        >
          {{ page_title }}

          <v-spacer></v-spacer>

        </v-card-title>

        <v-divider></v-divider>
        <v-row class="mt-1 mb-1 pr-3">
          <v-col
            cols="12"
            lg="8"
            md="12"
            xs="12"
          >
          <v-card-text
            class="d-flex align-center justify-end pt-0 pr-0 pb-0"
          >
            <v-text-field
              dense
              outlined
              v-model="search"
              append-icon="mdi-magnify"
              label="搜尋 組織名稱 / 帳號名稱 / 電子郵件"
              single-line
              hide-details
              @keypress.enter="searchKeyword(search)"
            ></v-text-field>
            <v-btn 
              @click="searchKeyword(search)"
              class="ml-3 btn_action btn_action_bg_linear"
            >
              <v-icon>
                mdi-magnify
              </v-icon>
            </v-btn>
          </v-card-text>
          </v-col>
          <v-col
            cols="12"
            lg="4"
            md="12"
            xs="12"
          >  
            <v-card-text
              class="d-flex align-center justify-end pa-0"
            >
              <v-select
                class="mr-2"
                label="排序"
                style="max-width:10em;"
                outlined
                return-object
                @change="changeSortBy(selected_sort_by)"
                v-model="selected_sort_by"
                :items="sort_by_items"
                item-value="value"
                item-text="name"
                hide-details
                dense
              >
              </v-select>
              <v-select
                label="顯示"
                style="max-width:7em;"
                outlined
                return-object
                @change="chagePerPage(selected_per_page)"
                v-model="selected_per_page"
                :items="per_page_items"
                item-value="value"
                item-text="name"
                hide-details
                dense
              >
              </v-select>
            </v-card-text>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-data-table :headers="headers" :items="items" hide-default-footer>
          <template v-slot:[`item.enable`] = "{item}">
            <v-btn
              v-if="(item.container_num  <= 0 ) || item.installed_gtm_num <= 0"
              class="ma-2"
              text
              icon
              color="red lighten-2"
            >
              <v-icon>mdi-stop-circle</v-icon>
            </v-btn>

            <v-btn
              v-else
              class="ma-2"
              text
              icon
              color="green lighten-2"
            >
              <v-icon>mdi-play-circle</v-icon>
            </v-btn>
        </template>

          <template v-slot:[`item.org_level`] = "{item}">
            <v-chip
              label
              dark
              class="justify-center"
              style="width: 100%; max-width: 120px"
              :color="getLevelColor(item.org_level)"
              v-text="level_mapper[item.org_level]"
            />
          </template>

          <template v-slot:[`item.created_at`] = "{item}">
            <span>{{$utils.formatTime(item.created_at, '-')}}</span>
          </template>

          <template v-slot:[`item.actions`] = "{item}">
            <div class="d-flex gap align-center">
              <v-btn
                class="text_default btn_default btn_default_bg_linear"
                outlined
                @click="viewInfo(item)"
                v-text="'檢視'"
              />

              <v-btn
                class="btn_action btn_action_bg_linear"
                outlined
                @click="help(item)"
                v-text="'代客操作'"
              />

              <v-btn
                class="adjust-sub-btn"
                outlined
                @click="adjustSubDialogSwitch(true, item)"
                v-text="'贈送訂閱方案'"
              />
            </div>
          </template>
        </v-data-table>

      <div class="text-center mt-5">
        <Pagination
          v-if="page_setting.is_show"
          :setting="page_setting"
        />
      </div>
    </v-card>

    <v-dialog v-model="adjust_sub_dialog.show" max-width="400" @click:outside="adjustSubDialogSwitch(false)">
      <v-form ref="adjust_sub_form" @submit.prevent="saveAdjustSub()">
        <v-card>
          <v-card-title class="justify-center font-weight-bold" v-text="'選擇贈送方案'" />
          <v-card-subtitle class="text-center mt-1 pa-0" v-text="'請選擇您的新訂閱方案與到期日。'" />
          <v-card-text class="pa-4 d-flex flex-column gap">
            <div>
              <p class="font-weight-bold black--text text-subtitle-1" v-text="'訂閱等級'" />
              <v-select
                v-model="adjust_sub_dialog.config.level_value"
                dense
                outlined
                hide-details="auto"
                :items="adjust_sub_dialog.config.level_items"
                :rules="[$utils.field_rules.required]"
              />
            </div>
            <div>
              <p class="font-weight-bold black--text text-subtitle-1" v-text="'數量'" />
              <v-text-field
                v-model="adjust_sub_dialog.config.product_quantity"
                dense
                outlined
                hide-spin-buttons
                type="number"
                hide-details="auto"
                :rules="[$utils.field_rules.required, (v) => $utils.field_rules.quantity(v, '<=', 12, '數量至多為12'), (v) => $utils.field_rules.quantity(v, '>=', 1, '數量至少為1')]"
              />
            </div>
          </v-card-text>
          <v-card-actions class="justify-end gap pa-4 pt-0">
            <v-btn class="grey white--text" v-text="'取消'" @click="adjustSubDialogSwitch(false)" />
            <v-btn class="primary" type="submit" :loading="adjust_sub_dialog.saving">送出</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { apiImpersonateUser } from '@/api/user.js'
import Pagination from '@/components/Utils/Pagination.vue'
import { apiGetOrganization, apiUpdateSub, apiGetProductList } from '@/api/admin.js'

  export default {
    name: 'OrganizationList',
		components: {
			Pagination
		},
    data() {
      return {
        // 頁面名稱
        page_title: '組織列表',
        // items
        items: [],
        headers: [
          { text: '啟用狀態', value: 'enable', sortable: false,},
          { text: '名稱', value: 'org_name', sortable: false,},
          { text: '等級', value: 'org_level', sortable: false,},
          { text: '安裝數', value: 'installed_gtm_num', sortable: false},
          { text: '容器數', value: 'container_num', sortable: false},
          { text: '建立時間', value: 'created_at', sortable: false},
          { text: '', value: 'actions', sortable: false },
        ],
        level_mapper: {
          null: 'No permission',
          '0': 'Experience',
          '10': 'Starter',
          '20': 'Business',
          '30': 'Enterprise',
          '99': 'Nineder'
        },
        search: '',
				page_setting: {
					is_show: false,
					selected_page: 1,
					total_page: 10,
					total_visible: 10,
				},
        selected_sort_by: {
          name: "註冊時間",
          value: "created_at",
        },
        sort_by_items: [
          {
            name: "註冊時間",
            value: "created_at",
          },
          {
            name: "容器數",
            value: "container_num",
          },
          {
            name: "安裝數",
            value: "installed_gtm_num",
          }
        ],
				selected_per_page: {
					name: "10筆",
					value: 10, 
				},
				per_page_items: [
					{
						name: "10筆",
						value: 10, 
					},
					{
						name: "24筆",
						value: 24, 
					},
					{
						name: "48筆",
						value: 48, 
					},
					{
						name: "100筆",
						value: 100, 
					},
				],
        adjust_sub_dialog: {
          show: false,
          user_info: null,
          config: {
            level_value: null,
            level_items: [
              { text: '請選擇', value: null },
            ],
            product_quantity: 1,
          },
          saving: false
        }
      }
    },
    created() {
      this.getData()
      this.getSubProductList()
    },
    methods: {
      async getData(){
        // 先抓網址上的頁碼，沒有預設就帶1
        let page_idx = parseInt(this.$route.query.page) ? parseInt(this.$route.query.page) : 1
        let limit = parseInt(this.$route.query.limit) ? parseInt(this.$route.query.limit) : this.selected_per_page.value
        this.search = this.$route.query.keyword ? this.$route.query.keyword : ''
        console.log('page_idx', page_idx)
        console.log('limit', limit)
        if (isNaN(limit)) {
          limit = 10
        }

        if (isNaN(page_idx)) {
          page_idx = 1
        }

        if (this.$route.query.sortby) {
          for (let idx = 0; idx < this.sort_by_items.length; idx++) {
            let sort_by_item = this.sort_by_items[idx]
            if (sort_by_item.value === this.$route.query.sortby) {
              this.selected_sort_by = sort_by_item
              break
            }
          }
        }

        try {
          const params = {
            page: page_idx,
            limit,
            key: this.search,
            sortby: this.selected_sort_by.value,
          }
          let result = await apiGetOrganization(params)
          let data = result.data
          console.log('data', data.content)
          this.items = data.content
					this.page_setting = {
						is_show: true,
						selected_page: page_idx,
						total_page: data.totalPages,
						total_visible: 10,
					}
					this.selected_per_page = {
						name: `${limit}筆`,
						value: limit, 
					}
          console.log('items', this.items)
        } catch (error) {
					let message = '取得組織列表失敗，原因: '
					if (error.response) {
						message += error.response.data.msg
					}
					else {
						message += error
					}
					this.$root.vtoast.show({
						message: message
					})
        }
      },
      getLevelColor(level) {
        let text = ''

          switch (level) {
            case null:
              text = 'red lighten-3'
              break
            case '0':
              text = 'grey'
              break;
            case '10':
              text = 'green'
              break;
            case '20':
              text = 'blue'
              break;
            case '30':
              text = 'purple'
              break;
            case '99':
              text = '#d31734'
              break;  
          }

        return text
      },
      viewInfo: function(item){
        console.log('組織名稱：',item)
        this.$router.push(`${item.org_id}`)
      },
			async searchKeyword(keyword){
				console.log('keyword:', keyword)
				let query = this.$route.query;
				let tmp_query = {...query, limit: this.selected_per_page.value, page: 1, keyword: keyword};
				console.log(tmp_query)
				try {
					this.$router.push({ path: this.$route.path, query: tmp_query})
				} catch (err) {
					console.log('ex')
					console.log('err.name', err.name)
					if (err.name !== 'NavigationDuplicated') {
						throw err;
					}
				}
			},
      changeSortBy(sort_by){
				let query = this.$route.query;
				let tmp_query = {...query,
          limit: this.selected_per_page.value, 
          page: 1,
          keyword: this.search,
          sortby:sort_by.value
        };
				console.log(tmp_query)
				try {
					this.$router.push({ path: this.$route.path, query: tmp_query})
				} catch (err) {
					console.log('ex')
					console.log('err.name', err.name)
					if (err.name !== 'NavigationDuplicated') {
						throw err;
					}
				}
      },
			async help(item){
				console.log(item)
				let user_id = item.principal_id
				try {
					let params = {
						"user_id": user_id 
					}
					let result = await apiImpersonateUser(params)
					console.log(result)
					let token = result.data.token
					let url = new URL(`${process.env.VUE_APP_USER_PLATFORM_URL}/user_impersonate`) 
					console.log(url.href)
					url.searchParams.append('access_token', token)
					window.open(url.href, '_blank')

				} catch (error) {
					let message = '取得使用者Token失敗，原因: '
					if (error.response) {
						message += error.response.data.msg
					}
					else {
						message += error
					}
					this.$root.vtoast.show({
						message: message
					})
				}
			},
      adjustSubDialogSwitch(status, user_info) {
        if (user_info) this.adjust_sub_dialog.user_info = user_info
        this.initAdjustSubForm(status)
        this.adjust_sub_dialog.show = status
      },
      initAdjustSubForm(status) {
        const user_info = this.adjust_sub_dialog.user_info
        if (status) {
          this.limitUserBuyProductList(user_info.org_level)
        } else {
          this.adjust_sub_dialog.config.level_value = null
          this.adjust_sub_dialog.config.product_quantity = 1
          this.adjust_sub_dialog.user_info = null
          this.$refs.adjust_sub_form.resetValidation()
        }
      },
      async saveAdjustSub() {
        let now_item = this.adjust_sub_dialog.config.level_items.find(item => {
          return item.value === this.adjust_sub_dialog.config.level_value
        })
        console.log('now_item', now_item)

        let is_confirm = confirm(`確定要新增\n訂閱方案: ${now_item.text} \n數量: ${this.adjust_sub_dialog.config.product_quantity}\n這個動作不能復原！`)

        if (!is_confirm) {
          return
        }

        this.adjust_sub_dialog.saving = true
        try {
          const form_validate = this.$refs.adjust_sub_form.validate()
          if (!form_validate) return
          const payload = {
            org_id: this.adjust_sub_dialog.user_info.org_id,
            ns_item_id: this.adjust_sub_dialog.config.level_value,
            quantity: Number(this.adjust_sub_dialog.config.product_quantity),
          }
          await apiUpdateSub(payload)
          this.adjustSubDialogSwitch(false)
          this.$root.vtoast.show({ message: '更新成功', color: 'primary' })
          await this.getData()
        } catch (error) {
          console.error('saveAdjustSub() error :', error)
          this.$root.vtoast.show({ message: `更新失敗，原因： ${error}`, color: 'error' })
        }
        this.adjust_sub_dialog.saving = false
      },
      async getSubProductList() {
        try {
          const params = {
            page: 1,
            limit: 100,
          }
          const res = await apiGetProductList(params)
          if (res.status !== 200 || res.data.code !== 200) throw new Error('取得商品列表失敗')
          let product_list = res.data?.data?.content.map(item => {
            const { ns_item_id, ...others } = item
            const product_name = item.name ? `${item.name}-` : ''
            const product_level = item.level ? this.level_mapper[item.level] : ''
            const product_quantity = item.quantity ? `(${item.quantity}日)` : ''

            return {
              text: `${product_name}${product_level}${product_quantity}`,
              value: ns_item_id,
              ...others,
            }
          }) || []
          product_list = product_list.filter(product => {
            return product.target === 'one_time_subscript' && (product.value.includes('NI') || product.value.includes('ni') )
          })
          console.log('product_list', product_list)
          const curr_level_items = [ ...this.adjust_sub_dialog.config.level_items ]
          this.adjust_sub_dialog.config.level_items = curr_level_items.concat(product_list)
        } catch (error) {
          console.error(error)
          this.$root.vtoast.show({ message: error, color: 'error' })
        }
      },
      limitUserBuyProductList(user_level) {
        if (!user_level) user_level = 0
        this.adjust_sub_dialog.config.level_items.forEach((item) => {
          item.disabled = !(Number(item.level) >= Number(user_level))
        })
      }
    },
  }
</script>

<style scoped>
h4 {
    color: #5b5b5b;
}

.adjust-sub-btn {
  background: linear-gradient(37deg, #BF8B2A, #EAC677, #F2D785, #F2D06B, #BF8B2A);
  border: 1px solid #BF8B2A;
  color: white;
}
</style>